import styled from 'styled-components';

export const SearchResultItem = styled.li`
  padding: 12px;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.color.borderColor};
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.color.inputBackground};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const SearchResultName = styled.div`
  font-weight: bold;
  margin-bottom: 4px;
`;

export const SearchResultContent = styled.div`
  font-size: 0.9em;
  color: ${({ theme }) => theme.color.secondaryText || '#666'};
  margin-bottom: 4px;
`;

export const SearchResultType = styled.div`
  font-size: 0.8em;
  color: ${({ theme }) => theme.color.secondaryText || '#999'};
`;
